// extracted by mini-css-extract-plugin
export default {"button":"ButtonNext_button__C5OW2","appear":"ButtonNext_appear__vGBfh","openTop":"ButtonNext_openTop__A5qiF"};